import React, { Component } from 'react';
import Dropzone from 'react-dropzone';
import { compose } from 'recompose';
import TextField from '@material-ui/core/TextField';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Button from '@material-ui/core/Button';
import Image from '@material-ui/icons/Image';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import KobooRoundInput from '../../constants/KobooRoundInput.css';
import KobooButton from '../Layout/KobooButton';
import styles from '../../constants/stylesDefault';
import * as routes from '../../constants/routes';
import { getRenters, postRenterPicture, putRenter } from '../../store/renters/actions';
import Spinner from '../Layout/Spinner';
import { handleError } from '../../store/infos/actions';
import withAuthorization from '../../hoc/withAuthorization';
import { ROLE_ADMIN } from '../../constants/roles';

const byPropKey = (propertyName, value) => () => (
  {
    [propertyName]: value,
  }
);

const INITIAL_STATE = {
  id: '',
  name: '',
  rib: '',
  logo: '',
  mail: '',
  pictureToUpload: null,
  sending: false,
  maxTimeBeforeEmbargo: 0,
};

const stateWithRenter = renter => (
  {
    id: renter.id,
    name: renter.name,
    rib: renter.rib,
    mail: renter.mail,
    logo: renter.logo,
    maxTimeBeforeEmbargo: Math.round(renter.max_time_before_embargo / 60),
  }
);

export class EditRenterForm extends Component {

  static propTypes = {
    authUser: PropTypes.object,
  };

  static supportedDropFiles = [
    'image/bmp',
    'image/x-ms-bmp',
    'image/png',
    'image/x-icon',
    'image/vnd.microsoft.icon',
    'image/jpeg',
    'image/gif',
    'image/svg+xml',
  ].toString();

  constructor(props) {
    super(props);
    this.state = { ...INITIAL_STATE };
  }

  static getDerivedStateFromProps(props, state) {
    let newState = null;
    if (props.authUser && props.roles) {
      const role = props.roles[props.authUser.uid];
      newState = {
        ...newState,
        role: role,
      };
      if (!props.renters && !props.pending && !props.error) {
        props.getRenters(props.authUser.ma, role);
      }
    }

    if (props.renters && props.match && state.id === INITIAL_STATE.id) {
      const renters = props.renters;
      const currentRenterId = props.match.params.renterId;
      const foundRenter = renters
        .find(renter => renter.id === currentRenterId);
      if (foundRenter) {
        newState = { ...newState, ...stateWithRenter(foundRenter) };
      }
    }
    return newState;
  }

  //Handle
  onSubmit = (event) => {
    const {
      id,
      name,
      rib,
      mail,
      maxTimeBeforeEmbargo,
    } = this.state;
    this.props.putRenter(
      this.props.authUser.ma,
      {
        name,
        rib,
        id,
        mail,
        maxTimeBeforeEmbargo,
      },
    ).then(renterId => {
      if (renterId) {
        if (this.state.pictureToUpload) { // picture To Upload after track sent
          this.props.postRenterPicture(
            this.props.authUser.ma,
            renterId,
            this.state.pictureToUpload,
            (progressEvent) => {
              const percentCompleted = Math.round((
                  progressEvent.loaded * 100
                )
                / progressEvent.total);
              this.props.dispatchInfo(this.state.pictureToUpload.name + ' -> '
                + percentCompleted
                + '% (' + progressEvent.loaded + ' / ' + progressEvent.total + ')');
            },
          ).then(value => {
            if (value) {
              this.props.history.push(routes.RENTER.replace(':renterId', renterId));
            }
          });
        } else {
          this.props.history.push(routes.RENTER.replace(':renterId', renterId));
        }
      }
    });
    event.preventDefault();
  };

  handleAddMedia = () => {
    this.dropzoneRef.open();
  };

  handleMediaDrop = (accepted, rejected) => {
    if (rejected.length) {
      this.props.handleError({ message: 'Le format du fichier n\'est pas compatible.' });
    } else {
      this.setState({
        logo: accepted[0].preview,
        pictureToUpload: accepted[0],
      });
    }
  };

  // Render

  render() {
    const {
      name,
      rib,
      mail,
      logo,
      maxTimeBeforeEmbargo,
    } = this.state;
    return (
      <form onSubmit={this.onSubmit} style={styles.center}>
        <Card>
          <CardContent>
            <Typography gutterBottom variant="h5" component="h2">
              Logo du loueur
            </Typography>
          </CardContent>
          <Dropzone
            style={styles.media}
            ref={(node) => {
              this.dropzoneRef = node
            }}
            accept={EditRenterForm.supportedDropFiles}
            onDrop={this.handleMediaDrop}
          >
            {logo ?
              <CardMedia
                component="img"
                image={logo}
                title='Logo du loueur'
              />
              :
              <div>
                <Typography variant="subtitle1">Glissez votre image dans cette zone.</Typography>
                <br/>
                <Image/>
              </div>
            }
          </Dropzone>
          <CardActions>
            <Button
              size="small"
              color="primary"
              onClick={ this.handleAddMedia }
            >
              Ajouter une image
            </Button>
          </CardActions>
        </Card>
        <TextField
          style={KobooRoundInput.round}
          placeholder="Nom"
          id="renter-name"
          type="text"
          onChange={event => this.setState(byPropKey('name', event.target.value))}
          margin="normal"
          value={name}
          InputProps={{
            disableUnderline: true,
          }}
        />
        <TextField
          style={KobooRoundInput.round}
          placeholder="Rib"
          id="renter-rib"
          type="text"
          onChange={event => this.setState(byPropKey('rib', event.target.value))}
          margin="normal"
          value={rib}
          InputProps={{
            disableUnderline: true,
          }}
        />
        {this.state.role === ROLE_ADMIN &&
          <TextField
            style={KobooRoundInput.round}
            placeholder="Mail"
            id="renter-mail"
            type="text"
            onChange={event => this.setState(byPropKey('mail', event.target.value))}
            margin="normal"
            value={mail}
            InputProps={{
              disableUnderline: true,
            }}
          />
        }
          <Typography>Définir le temps avant que l'embargo se déclenche (en minutes)</Typography>
          <TextField
            style={KobooRoundInput.round}
            placeholder={maxTimeBeforeEmbargo}
            type="number"
            inputProps={{
              min : 0,
              step : 1
            }}
            id="renter-maxTimeBeforeEmbargo"
            value={maxTimeBeforeEmbargo}
            onChange={
              event => this.setState(byPropKey('maxTimeBeforeEmbargo', Number(event.target.value)))
            }
            helperText={maxTimeBeforeEmbargo < 0 ? 'La valeur doit être égale ou supérieur à 0' : ''}
            error={maxTimeBeforeEmbargo < 0}
            FormHelperTextProps={{
              style: KobooRoundInput.helperText
            }}
            InputProps={{
              disableUnderline: true,
            }}
          >
          </TextField>
        <KobooButton disabled={this.props.sending} type="submit">
          {this.props.sending
            ?
            <Spinner
              style={{
                parent: { margin: '4px auto 0' },
                child: {},
              }}
            />
            : 'Éditer'}
        </KobooButton>
      </form>
    );
  }
}

function mapStateToProps(state) {
  return {
    authUser: state.users.authUser,
    renters: state.renters.content,
    pending: state.renters.pending,
    sending: state.renters.sending,
    error: state.renters.error,
  };
}

export default compose(
  withAuthorization(authUser => !!authUser),
  connect(
    mapStateToProps,
    {
      getRenters,
      putRenter,
      postRenterPicture,
      handleError,
    },
  ),
)(EditRenterForm);



// WEBPACK FOOTER //
// ./src/components/Renter/EditRenterForm.jsx